import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { ColumnFilter } from '../ColumnFilter';
import { ColumnDistributorFilter } from '../ColumnDistributorFilter';
import { FiltersContent } from './partials';
export var ColumnFilters = function ColumnFilters(_ref) {
  var filters = _ref.filters,
    onFiltersChange = _ref.onFiltersChange,
    onRestoreFilters = _ref.onRestoreFilters,
    _ref$activeFilters = _ref.activeFilters,
    activeFilters = _ref$activeFilters === void 0 ? [] : _ref$activeFilters;
  return React.createElement(FiltersContent, null, React.createElement(Flex, null, filters.filter(function (filt) {
    return !filt.id.includes('distributors') && filt.id.includes('index') || filt.id.includes('region');
  }).map(function (filter, index) {
    var activeFilter = activeFilters.length && activeFilters.find(function (item) {
      return item.id === filter.id;
    });
    return React.createElement(ColumnFilter, {
      key: index,
      filter: filter,
      onChange: onFiltersChange,
      onRestore: onRestoreFilters,
      activeFilter: activeFilter
    });
  })), filters.filter(function (filt) {
    return filt.id.includes('distributors');
  }).map(function (filter, index) {
    var activeFilter = activeFilters.length && activeFilters.find(function (item) {
      return item.id === filter.id;
    });
    return React.createElement(ColumnDistributorFilter, {
      key: index,
      filter: filter,
      onChange: onFiltersChange,
      onRestore: onRestoreFilters,
      activeFilter: activeFilter
    });
  }));
};